import { request } from "@/api/server/index";

export default {
  //  V006_管理者ダッシュボード画面
  Dashboard: {
    // 管理者
    ///初期表示
    indexAdminDashboard(params) {
      return request({
        url: "/adminDashboard/indexAdminDashboard",
        data: params,
        method: "post"
      });
    },
    // 部署のデータ取得
    searchDepartmentList(params) {
      return request({
        url: "/adminDashboard/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    // ユーザのデータ取得
    searchUserList(params) {
      return request({
        url: "/adminDashboard/searchUserList",
        data: params,
        method: "post"
      });
    },
    // 保険料のデータ取得
    getBranchDashboardAp(params) {
      return request({
        url: "/adminDashboard/searchAp",
        data: params,
        method: "post"
      });
    },
    // 見込み案件のデータ取得
    getBranchDashboardProposal(params) {
      return request({
        url: "/adminDashboard/searchProposal",
        data: params,
        method: "post"
      });
    },
    //対応履歴のデータ取得
    getBranchDashboardContact(params) {
      return request({
        url: "/adminDashboard/searchContact",
        data: params,
        method: "post"
      });
    },
    // Top10成約商品のデータ取得
    getBranchDashboardProduct(params) {
      return request({
        url: "/adminDashboard/searchProduct",
        data: params,
        method: "post"
      });
    },
    // 募集人
    // 初期表示
    indexDashboard(params) {
      return request({
        url: "/dashboard/indexDashboard",
        data: params,
        method: "post"
      });
    },
    // 保険料のデータ取得
    searchBranchDashboardAp(params) {
      return request({
        url: "/dashboard/searchAp",
        data: params,
        method: "post"
      });
    },
    // 見込み案件のデータ取得
    searchBranchDashboardProposal(params) {
      return request({
        url: "/dashboard/searchProposal",
        data: params,
        method: "post"
      });
    },
    //対応履歴のデータ取得
    searchBranchDashboardContact(params) {
      return request({
        url: "/dashboard/searchContact",
        data: params,
        method: "post"
      });
    },
    // Top10成約商品のデータ取得
    searchBranchDashboardProduct(params) {
      return request({
        url: "/dashboard/searchProduct",
        data: params,
        method: "post"
      });
    }
  }
};
